<div class="toolbar">
  @if(authenticationService.isSignedIn$ | async) {
    @if(hasCbp$ | async) {
      <div class="navbar">
        @for (navItem of carBodyPlannerItems; track navItem) {
          <a routerLink="{{ navItem.path }}"
             routerLinkActive="active">
            <li class="nav-item">
              {{
                navItem.text | translate
              }}
            </li>
          </a>
        }
      </div>
    }

    @if(hasFai$ | async) {
      <div class="navbar">
        @for (navItem of feasibilityAiItems; track navItem) {
          <a routerLink="{{ navItem.path }}"
             routerLinkActive="active">
            <li class="nav-item">
              {{
                navItem.text | translate
              }}
            </li>
          </a>
        }
      </div>
    }

    @if(cloudApplicationService.hasAppStream$| async) {
      <div class="navbar">
        @for (navItem of customerItems; track navItem) {
          <a routerLink="{{ navItem.path }}"
              routerLinkActive="active">
            <li class="nav-item">
              {{
                navItem.text | translate
              }}
            </li>
          </a>
        }
      </div>
    }

    @if(hasAcls$ | async) {
      <div class="navbar">
        @for (navItem of aclsItems; track navItem) {
          <a routerLink="{{ navItem.path }}" routerLinkActive="active">
            <li class="nav-item">{{ navItem.text  | translate }}</li>
          </a>
        }
      </div>
    }

    @if(!(hasAnyApp$ | async)) {
      <div class="navbar">
        @for (navItem of welcomeItems; track navItem) {
          <a routerLink="{{ navItem.path }}" routerLinkActive="active">
            <li class="nav-item">{{ navItem.text | translate }}</li>
          </a>
        }
      </div>
    }

    <div class="navbar-gap"></div>

    @if(authorizationService.isCPAdmin()) {
        <div class="navbar">
        @for (navItem of cloudPortalAdminItems; track navItem) {
          <a routerLink="{{ navItem.path }}"
             routerLinkActive="active">
            <li class="nav-item">
              {{
                navItem.text | translate
              }}
            </li>
          </a>
        }
      </div>
    }

    @if(authorizationService.isCusMan()) {
      <div class="navbar">
        @for (navItem of customerManagerItems; track navItem) {
          <a routerLink="{{ navItem.path }}"
             routerLinkActive="active">
            <li class="nav-item">
              {{
                navItem.text | translate
              }}
            </li>
          </a>
        }
        </div>
    }
    <!--@if(authorizationService.isCustomerAdmin()) {
      <div class="navbar">
        @if(afApplicationService.hasAppStream$ | async) {
          @for (navItem of customerAdminItemsStream; track navItem) {
            <li class="nav-item">
              <a routerLink="{{ navItem.path }}"
              routerLinkActive="active">{{
                navItem.text | translate
              }}</a>
            </li>
            }
          }
        @else if(afApplicationService.hasLicenseServer$ | async) {
          @for (navItem of customerAdminItemsLic; track navItem) {
            <li class="nav-item">
              <a routerLink="{{ navItem.path }}"
              routerLinkActive="active">{{
                navItem.text | translate
              }}</a>
            </li>
            }
           } @else {
            @for (navItem of customerAdminItems; track navItem) {
              <li class="nav-item">
                <a routerLink="{{ navItem.path }}"
                routerLinkActive="active">{{
                  navItem.text | translate
                }}</a>
              </li>
              }
            }
      </div>
    }-->
  }
</div>
